export const groupBy = <T, K extends PropertyKey>(items: T[], getKey: (item: T) => K) => {
    const result: {[P in K]?: T[]} = {};
    for (const item of items) {
        const key = getKey(item);
        (result[key] ?? (result[key] = [])).push(item);
    }
    return result;
};
